// Folds an INSERT_ZIP_MAPPINGS response into a cached subregion list. Shared by the two pages
// that own the mutation, which cache it under different shapes.
//
// It is ON CONFLICT DO NOTHING, so an existing row comes back in neither `returning` nor as an
// error. Group by subregion (a batch can span several) and dedupe against the cache (a partial
// conflict returns only the inserted rows).
export const mergeInsertedZips = (subregions = [], returning = []) => {
    if (!returning.length) return subregions;

    const freshBySubregion = returning.reduce((acc, mapping) => {
        (acc[mapping.subregion_id] = acc[mapping.subregion_id] || []).push(mapping);
        return acc;
    }, {});

    return subregions.map((subregion) => {
        const fresh = freshBySubregion[subregion.subregion_id];
        if (!fresh) return subregion;

        const existing = new Set((subregion.zips || []).map((z) => z.zip));
        const added = fresh.filter((z) => !existing.has(z.zip));
        if (!added.length) return subregion;

        return { ...subregion, zips: [...(subregion.zips || []), ...added] };
    });
};

export const genName = (subregion, idx) => {
    return subregion.name || `Subregion ${idx}`;
};

export const getPrefWarehouse = (id, locations = []) => {
    return locations.reduce((acc, location) => {
        if (id) {
            return location.location_id === id ? location : acc;
        } else {
            return location.preferred_inbound ? location : acc;
        }
    }, locations[0]);
};
